export default "__VITE_ASSET__$BprqXuR__"